import _ from "lodash";
import { getThunkAndSlice } from "@src/store/getThunkAndSlice";
import { pricingActions } from "..";
import { RootState } from "@src/store/store";
import { EventInventoryRecord, getInventoryCacheEventId } from "@src/store/pricing/queryEventInventoryAllSlice";

const initialState = {
	added: true,
};

export const mergeTags = (existing: string | null | undefined, added: Array<string>) => {
	const merged = _.uniq([...(existing ? existing.split("|") : []), ...added]).filter(Boolean);
	return merged.length ? merged.join("|") : null;
};

export const { thunk: addItemTags, slice: addItemTagsSlice } = getThunkAndSlice<
	{
		ItemIds: Array<number>;
		TagDescriptions: Array<string>;
	},
	typeof initialState
>({
	initialState,
	path: "/api/System/AddItemsTags",
	method: "post",
	onAfterRequest: async (data, params, state, dispatch) => {
		const rootState = state as RootState;
		const eventId = getInventoryCacheEventId(rootState);
		const inventoryAllState = rootState.pricing.eventInventoryAll.data;
		const listingIds = new Set(inventoryAllState.filter((x) => params.ItemIds.includes(x.Item_ID)).map((x) => x.Listing_ID));
		const newData = inventoryAllState.map((x) => {
			return listingIds.has(x.Listing_ID) ? { ...x, Tags: mergeTags(x.Tags, params.TagDescriptions) } : x;
		});

		dispatch(pricingActions.updateInventoryAll({ data: newData, eventId }));

		if (rootState.pricing.globalInventory.data.length) {
			const newGlobalData = (rootState.pricing.globalInventory.data as Array<EventInventoryRecord>).map((x) => {
				return listingIds.has(x.Listing_ID) ? { ...x, Tags: mergeTags(x.Tags, params.TagDescriptions) } : x;
			});
			dispatch(pricingActions.updateGlobalInventory({ data: newGlobalData }));
		}

		return data;
	},
});
